import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import HistoryPage from './HistoryPage';

export default flowRight(withVerificationGuard, withAuthGuard())(HistoryPage);
